import React, { useState, useEffect } from "react";
import "./Form4.scss";
import { FiArrowRight, FiX } from "react-icons/fi";
import Select from 'react-select';
import { connect } from "react-redux";

import { signup } from "../../../store/auth/actions";

const selectCustomStyles = {
  menu: (provided, state) => ({
    ...provided,
  }),
  control: () => ({
    background: "#ffffff",
    display: "flex",
    width: "100%",
    // height: "3rem",
    borderRadius: "unset",
    border: "1px solid #fcfcfc",
    cursor: "pointer",
    fontSize: "2rem",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#000000",
    paddingLeft: "1.2rem",
    fontSize: "2rem",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    paddingLeft: "2rem"
  })
};

const Form4 = (props) => {
  const [selectedOpt, setSelectedOpt] = useState([]);
  const data = [
    {
      value: "Accordionist",
      label: "Accordionist",
    },
    {
      value: "Agent",
      label: "Agent",
    },
    {
      value: "Backing Singer",
      label: "Backing Singer",
    },
    {
      value: "Band",
      label: "Band",
    },
    {
      value: "Banjoist",
      label: "Banjoist",
    },
    {
      value: "Bassists",
      label: "Bassists",
    },
    {
      value: "Bass Player",
      label: "Bass Player",
    },
    {
      value: "Cellist",
      label: "Cellist",
    },
    {
      value: "Clarinetist",
      label: "Clarinetist",
    },
    {
      value: "Composer",
      label: "Composer",
    },
    {
      value: "Conductor",
      label: "Conductor",
    },
    {
      value: "DJ",
      label: "DJ",
    },
  ];
  const checkExistVal = (selectedVal) => {
    const val = selectedOpt.filter(val => {
     return val.value === selectedVal.value
    })
    return val;
  }

  const handleChange = async(selectedVal) => {
    if(selectedOpt.length){
      const existVal = await checkExistVal(selectedVal);
      if(!existVal.length){
        setSelectedOpt([...selectedOpt, selectedVal])
      }
    }else{
      setSelectedOpt([...selectedOpt, selectedVal])
    }
  }

  const disabledBtn = () => {
    if (!selectedOpt.length)
      return true;
    return false;
  };

  const handleSubmit = async() => {
    await props.signup({
      userId: props.userData.signupData.userId,
      music_genre: selectedOpt,
    });
    props.clicking();
  };

  return (
    <div className="Form4 w-100">
      <div className="h1">I am a ...</div>
      <div className="note text-muted text-left">
        Select up to 5 skills. If you don't see what you're looking for try
        searching.
      </div>
      <div className="input-wrapper">
        {/* <input
          type="search"
          className="input form-control"
          placeholder="Enter a skill"
          required
        /> */}
        <Select
          styles={selectCustomStyles}
          value={selectedOpt}
          components={{
            DropdownIndicator: () => null,
            IndicatorSeparator: () => null,
          }}
          onChange={handleChange}
          options={data}
        />
      </div>
      {/* <div className="skills">
        {data.map((item, i) => (
          <div
            className="skill"
            key={i}
            onClick={() => setSkills([...skill, item])}
          >
            {item.name}
          </div>
        ))}
      </div> */}

      <div className="skills-selected">
        {selectedOpt.map((item, i) => (
          <div className="skill" key={i}>
            {item.label}
            <FiX
              className="ml-3"
              onClick={(e) => {
                setSelectedOpt(
                  selectedOpt.filter(function (skl) {
                    return skl.value !== item.value;
                  })
                );
              }}
            />
          </div>
        ))}
      </div>

      <div className="my-5"></div>
      <div className="d-flex justify-content-end align-items-center ">
        <button
          className="btn btn-primary rounded-3 btn-lg mt-4"
          disabled={disabledBtn()}
          onClick={()=> handleSubmit()}
        >
          Next
          <FiArrowRight className="ml-3" />
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userData: state.auth,
});

export default connect(mapStateToProps, {
  signup
})(Form4);
